/**
 * Device detection utilities for SafeVibe
 */

/**
 * Check if the current device is mobile
 */
export function isMobileDevice(): boolean {
  try {
    // Check user agent for mobile indicators
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    
    // Common mobile user agent patterns
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    
    // Also check screen width as backup
    const isSmallScreen = typeof window !== 'undefined' && window.screen ? window.screen.width <= 768 : false;
    
    return mobileRegex.test(userAgent) || isSmallScreen;
  } catch {
    return false;
  }
}

/**
 * Check if the current device is tablet
 */
export function isTabletDevice(): boolean {
  try {
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    
    // Tablet-specific patterns  
    const tabletRegex = /ipad|android(?!.*mobile)|kindle|silk/i;
    
    // Medium screen size range
    const isMediumScreen = typeof window !== 'undefined' && window.screen ? 
      window.screen.width > 768 && window.screen.width <= 1024 : false;
    
    return tabletRegex.test(userAgent) || isMediumScreen;
  } catch {
    return false;
  }
}

/**
 * Get device type as string
 */
export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
  if (isMobileDevice()) return 'mobile';
  if (isTabletDevice()) return 'tablet';
  return 'desktop';
}

/**
 * Check if the user should see mobile warning
 * Shows warning for mobile but not tablet (tablets have better UX)
 */
export function shouldShowMobileWarning(): boolean {
  return isMobileDevice() && !isTabletDevice();
}
